<mat-card class="rounded-2xl border border-gray-6 shadow-sm h-full overflow-hidden">
  <mat-card-header class="bg-gray-1 py-4 px-6 border-b border-gray-6 flex flex-row items-center w-full">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-3 text-indigo-11">
        <mat-icon>payments</mat-icon>
      </div>
      <mat-card-title class="text-lg! font-bold! m-0! text-gray-12!">Conditions financières</mat-card-title>
    </div>
    @if (editable()) {
      <div class="ml-auto flex items-center gap-2">
        <etxe-property-section-reminder
          [items]="missingItems()"
          [editMode]="editMode()"
          (actionClicked)="onEdit()"
        />
        <button
          mat-icon-button
          class="text-indigo-11 bg-indigo-a3 hover:bg-indigo-a4 transition-colors rounded-full"
          (click)="editMode() ? onCancel() : onEdit()"
        >
          <mat-icon>{{ editMode() ? 'close' : 'edit' }}</mat-icon>
        </button>
      </div>
    }
  </mat-card-header>
  <mat-card-content class="p-0">
    @if (!editMode()) {
      <etxe-property-financials-display
        [financials]="property().financials"
        [isInCoOwnership]="!!property().keyInfo.coOwnership?.isInCoOwnership"
        [residenceType]="property().definition.residenceType"
        [habitableSurface]="property().keyInfo?.surface?.habitable"
        [propertyDvf]="property().geospatial?.dvf"
        [propertyLocation]="property().location"
        [propertyType]="property().definition?.propertyType"
        [propertyId]="property()._id"
      ></etxe-property-financials-display>
    } @else {
      <div class="bg-gray-2 p-6">
        <etxe-property-financials-form
          [propertyId]="property()._id"
          [dto]="property().financials"
          [propertyIsCoOwnership]="!!property().keyInfo.coOwnership?.isInCoOwnership"
          [residenceType]="property().definition.residenceType"
          [habitableSurface]="property().keyInfo?.surface?.habitable"
          [isNewBuild]="property().construction?.year === PropertyConstructionPeriod.SINCE_2019"
          [propertyLocation]="property().location"
          [propertyType]="property().definition?.propertyType"
          [propertyDvf]="property().geospatial?.dvf"
          (dtoChanged)="onDtoChanged($event)"
        ></etxe-property-financials-form>
        <div class="flex justify-end gap-3 mt-6 border-t border-gray-6 pt-4">
          <button mat-button (click)="onCancel()">Annuler</button>
          <button mat-flat-button class="primary" [disabled]="saving()" (click)="onSubmit()">
            Enregistrer
          </button>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
